module.exports = __webpack_public_path__ + "img/door4.a1fe112a.png";